import { render, staticRenderFns } from "./FileEmail.vue?vue&type=template&id=382d6160&"
import script from "./FileEmail.vue?vue&type=script&lang=js&"
export * from "./FileEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports